import type React from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import GradientButton from "app/pages/sales-intelligence/modules/ai-agent/components/GradientButton/GradientButton";

type Props = {
    onClick: () => void;
};

export const SuperAgentButton: React.FC<Props> = ({ onClick }) => {
    const { translate } = useTranslate();

    return (
        <GradientButton
            variant="ghostSmall"
            onClick={onClick}
        >
            {translate("si.ai-super-agent.button")}
        </GradientButton>
    );
};
